/*! ******************************************************************************************************** *
 *
 * Copyright 2011-2020 Markus Schütz
 * Copyright 2025 Oidis
 *
 * SPDX-License-Identifier: BSD-2-Clause
 * The BSD-2-Clause license for this file can be found in the LICENSE.txt file included with this distribution
 * or at https://spdx.org/licenses/BSD-2-Clause.html#licenseText
 *
 * ********************************************************************************************************* */

export class WorkerPool {
    constructor() {
        this.workers = {};
    }

    getWorker(url) {
        if (!this.workers[url]) {
            this.workers[url] = [];
        }

        if (this.workers[url].length === 0) {
            let worker = new Worker(url);
            this.workers[url].push(worker);
        }

        let worker = this.workers[url].pop();

        return worker;
    }

    returnWorker(url, worker) {
        this.workers[url].push(worker);
    }
}
